import React, { useContext, useState } from "react";
import Container from "../Container";
import styles from "./index.module.scss";
import { Dropdown, Button } from "react-bootstrap";
import { AuthContext } from "../../providers/AuthProvider";
import { SettingsContext } from "../../providers/SettingsProvider";
import { isLoggedIn } from "../../helpers/user";
import { useNavigate } from "react-router-dom";
import { tgLink } from "../../constants";
import Support from "../../modals/Support";

const Header = () => {
  const [supportPopup, setSupportPopup] = useState(false);
  const { user } = useContext(AuthContext);
  const { monthIndex } = useContext(SettingsContext);
  const navigate = useNavigate();
  const isAdmin = Boolean(user?.me?.isAdmin);

  const showPopup = () => {
    setSupportPopup(true);
  };

  const onHidePopup = () => {
    setSupportPopup(false);
  };

  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.headerCnt}>
          <img
            className={styles.logo}
            src="/logo.svg"
            alt=""
            onClick={() => navigate("/home")}
          />
          <div className={styles.beta}>BETA</div>
          <Button
            onClick={() => window.test().test}
            style={{ display: "none" }}
          >
            Test
          </Button>
          {isLoggedIn() ? (
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <i style={{ fontSize: 18 }} className="bi bi-person-circle"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {isAdmin && (
                  <>
                    <Dropdown.Item onClick={() => navigate("/administration")}>
                      <i className="bi bi-people-fill"></i>&nbsp;Адмінка
                    </Dropdown.Item>
                    <Dropdown.Divider />
                  </>
                )}
                <Dropdown.Item onClick={() => navigate("/leagues")}>
                  <i className="bi bi-list-task"></i>&nbsp;Ліги
                </Dropdown.Item>
                <Dropdown.Item onClick={() => navigate("/private-leagues")}>
                  <i className="bi bi-incognito"></i>&nbsp;Приватні ліги
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => navigate(`/standings/${monthIndex}`)}
                >
                  <i className="bi bi-calendar3"></i>&nbsp;Рейтинг місяця
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => navigate("/rules")}>
                  <i className="bi bi-paperclip"></i>&nbsp;Правила
                </Dropdown.Item>
                <Dropdown.Item onClick={() => window.open(tgLink, "_blank")}>
                  <i className="bi bi-telegram"></i>&nbsp;Telegram
                </Dropdown.Item>
                <Dropdown.Item onClick={() => showPopup()}>
                  <i className="bi bi-headset"></i>&nbsp;Техпідтримка
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => navigate("/logout")}>
                  <i className="bi bi-box-arrow-right"></i>&nbsp;Вийти
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Button
              className={styles.white}
              variant="link"
              onClick={() => navigate("/login")}
            >
              Увійти
            </Button>
          )}
        </div>
      </Container>
      <Support show={supportPopup} onHide={onHidePopup} />
    </header>
  );
};

export default Header;
